<!--
  ~ Copyright (c) 2020 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<div [kitContainer]="model" class="app-root-container"></div>
